<template>
	<div>
		<Loader />
		<div>
			<ValidationObserver ref="observer" v-slot="{ passes }" v-if="!isDone">
				<form @submit.prevent="passes(() => {})" onkeydown="return event.key != 'Enter';">
					<h3 class="d21-modal-content__heading">{{ T("ticketing_login_data") }}</h3>
					<div class="mdl-grid">
						<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
							<label>{{ T("email") }}</label>
							<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.Email" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<template v-if="isRegisterForm || doResetPassword">
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<label>{{ T("password") }}</label>
								<ValidationProvider name="password" rules="required|min:2" v-slot="{ errors }">
									<input v-model.trim="Profile.Credentials.Password" type="password" class="mdl-textfield__input" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<label>{{ T("password_repeat") }}</label>
								<ValidationProvider name="password_repeat" rules="required|min:2" v-slot="{ errors }">
									<input v-model.trim="Profile.Credentials.ex.passwordRepeat" type="password" class="mdl-textfield__input" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<passwordStrength :password="Profile.Credentials.Password" :password_repeat="Profile.Credentials.ex.passwordRepeat" @isValid="isValid => isPasswordValid = isValid" />
							</div>
						</template>
						<template v-else>
							<a class="changePassword" @click="doChangePassword">{{ T("ticketing_change_password")}}</a>
						</template>
					</div>
					<h3 class="addressData d21-modal-content__heading">{{ T("ticketing_address_data") }}</h3>
					<div class="mdl-grid">
						<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
							<label>{{ T("mobile") }}</label>
							<ValidationProvider name="mobile" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.Mobile" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--6-col mdl-cell-6-col-m form-group">
							<label>{{ T("givenname") }}</label>
							<ValidationProvider name="givenname" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.GivenName" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--6-col mdl-cell-6-col-m form-group">
							<label>{{ T("lastname") }}</label>
							<ValidationProvider name="lastname" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.LastName" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--12-col mdl-cell-12-col-m form-group">
							<label>{{ T("street") }}</label>
							<ValidationProvider name="street" rules="required|min:2" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.Street" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--4-col mdl-cell-4-col-m form-group">
							<label>{{ T("postalcode") }}</label>
							<ValidationProvider name="postalcode" rules="required|min:2" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.PostalCode" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--8-col mdl-cell-8-col-m form-group">
							<label>{{ T("city") }}</label>
							<ValidationProvider name="city" rules="required|min:2" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.City" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
					</div>
				</form>
			</ValidationObserver>
			<div class="mdl-grid">
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success" v-if="isRegistered">
					<i class="material-icons">check_circle</i>
					<span>{{ T("ticketing_register_success", Profile.Contact.Email) }}</span>
					<br />
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m mdl-cell--12-col-mlinks form-group warning" v-else-if="isExisting">
					<i class="material-icons">warning</i>
					<span>{{ T("ticketing_profile_exists")}}</span>
					<a @click="passwordForgotten">{{ T("ticketing_did_you_forget_password")}}</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Loader from "../ui/loader.vue";
	import baseMixin from "../../mixins/base";
	import passwordStrength from '../ui/password-strength.vue'
	import {
		EventBus
	} from "../../scripts/_eventBus.js";
	import 'vueperslides/dist/vueperslides.css'
	import {
		ValidationObserver,
		ValidationProvider,
		extend
	} from "vee-validate";
	import {
		alpha_spaces,
		between,
		email,
		is,
		max,
		min,
		regex,
		required
	} from "vee-validate/dist/rules";

	export default {
		mixins: [baseMixin],
		components: {
			Loader,
			ValidationObserver,
			ValidationProvider,
			passwordStrength
		},
		name: "d21-modal-register",
		data() {
			return {
				isNextButtonActive: false,
				isValid: true,
				isRegistered: false,
				buttonShownText: "Änderungen speichern",
				buttonHiddenText: "Änderungen speichern",
				isPasswordValid: false,
				doResetPassword: false,
				isUpdated: false,
				isExisting: false
			};
		},
		created() {
			extend("alpha_spaces", alpha_spaces);
			extend("required", required);
			extend("between", between);
			extend("email", email);
			extend("is", is);
			extend("min", min);
			extend("max", max);
			extend("regex", regex);

			EventBus.$on("show:login", (status) => {
				if (!status) this.cleanInputFields();
			});
		},
		mounted() {
			EventBus.$on("onProfileRegister", args => {
				this.saveChanges();
			});
		},
		computed: {
			isRegisterForm() {
				return !this.Profile.Token || this.$route.params.section === 'register';
			},
			isDone() {
				return this.isRegistered || this.isUpdated;
			}
		},
		methods: {
			cleanInputFields() {
				this.Profile.Contact = {};
				this.Profile.Credentials.Password = '';
				this.Profile.Credentials.ex.passwordRepeat = '';
			},
			toLogin() {
				this.$router.push(`/${this.$route.params.channel}/profile/login`);
			},
			saveChanges() {
				//
				const isRegistration = !this.Profile.Token;
				const fnUpdatePassword = (token) => {
					const passwordParameter = encodeURIComponent(this.Profile.Credentials.Password);
					const tokenParameter = encodeURIComponent(token);
					this.apiRequest(`/profile/${this.$route.params.channel}/approvepasswordreset?token=${tokenParameter}&newPassword=${passwordParameter}`, null, "GET", result => {
						if (result.Meta.IsValid) {
							if (isRegistration) {
								this.isRegistered = true;
							} else {
								this.isUpdated = true;
								this.Profile.Token = token;
							}
						} else {
							this.isRegistered = false;
							this.isUpdated = false;
						}
						EventBus.$emit("registerPendingStatus", false);
					}, error => {
						EventBus.$emit("registerPendingStatus", false);
					});
				};

				//
				if (!this.$refs.observer) return;
				EventBus.$emit("registerPendingStatus", true);

				this.$refs.observer.validate().then((isValid) => {
					if (isValid) {
						this.apiRequest(`/profile/${this.$route.params.channel}/update`, this.Profile, "PUT", result => {
							if (result.Meta.IsValid) {
								this.isExisting = false;
								if (isRegistration || this.doResetPassword) {
									fnUpdatePassword(result.Value.Token);
								} else {
									this.isUpdated = true;
									EventBus.$emit("registerPendingStatus", false);
								}
							} else {
								this.isExisting = result.Meta.Message === 'user already exists';
								this.isRegistered = false;
								this.isUpdated = false;
								EventBus.$emit("registerPendingStatus", false);
							}
						}, error => {
							EventBus.$emit("registerPendingStatus", false);
						});
					}
				});
			},
			passwordForgotten() {
				this.$emit("onPasswordForgotten", null);
				this.$modals.hide('register');
				this.$modals.show('forgot-password');
			},
			doChangePassword() {
				this.Profile.Credentials.Password = null;
				this.Profile.Credentials.ex = {
					passwordRepeat: null
				};
				this.doResetPassword = true;
			}
		},
		watch: {
			isDone(newValue) {
				EventBus.$emit("register:isDone", newValue);
			}
		}
	}
</script>